<template>
  <b-form-group
    label="Mobile"
    label-for="mobile"
  >
    <b-input-group>
      <b-input-group-prepend is-text>
        TR (+9)
      </b-input-group-prepend>
      <cleave
        id="mobile"
        v-model="itemData.mobile"
        class="form-control"
        :raw="false"
        :options="options.mobile"
        placeholder="Mobile"
      />
    </b-input-group>
  </b-form-group>
</template>
<script>
import {
  BFormGroup, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.tr'

export default {
  name: 'MobileNumber',
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormGroup,
    Cleave,
  },
  data() {
    return {
      options: {
        mobile: {
          phone: true,
          phoneRegionCode: 'TR',
        },
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['contacts/dataItem']
    },
  },
}
</script>
